(() => {
  const form = document.getElementById('vvseo-finder-form');
  const results = document.getElementById('vvseo-finder-results');
  const status = document.getElementById('vvseo-finder-status');
  if (!form || !results || !status) return;
  const more = document.getElementById('vvseo-finder-more');
  let visibleLimit = 12;
  const cards = [...results.querySelectorAll('.vvseo__product')];
  const render = () => {
    const values = new FormData(form);
    const known = values.get('size') === 'known';
    const budget = values.get('budget');
    const kind = values.get('kind');
    const theme = values.get('theme');
    let matches = 0;
    for (const card of cards) {
      const cardKind = card.dataset.kind;
      const fitsSize = known || cardKind === 'accessory';
      const fitsBudget = budget === 'any' || Number(card.dataset.price) < 25;
      const fitsKind = kind === 'any' || kind === cardKind;
      const fitsTheme = theme === 'any' || card.dataset.theme === theme;
      const show = fitsSize && fitsBudget && fitsKind && fitsTheme;
      if (show) matches += 1;
      card.hidden = !show || matches > visibleLimit;
    }
    if (more) more.hidden = matches <= visibleLimit;
    status.textContent = matches ? `${matches} current ${matches === 1 ? 'idea' : 'ideas'} match these choices. ${matches > visibleLimit ? `Showing ${visibleLimit}. ` : ''}Open a product to check its details.` : 'No current match in this combination. Try another filter or browse all gifts.';
  };
  form.addEventListener('change', () => { visibleLimit = 12; render(); });
  more?.addEventListener('click', () => { visibleLimit += 12; render(); });
  render();
})();
